import { defineComponent as _defineComponent } from 'vue'
import ClientCompanyDetailsEditor from '@/app/components/settings/client/ClientCompanyDetailsEditor.vue';
import { Client, UploadedFile, ClientFileCategories } from 'ah-api-gateways';
import FileUploadCounter from 'ah-common-lib/src/common/components/upload/FileUploadCounter.vue';
import DocumentsUploader from '@/app/components/settings/client/DocumentsUploader.vue';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { computed, ref } from 'vue';
import { useToast } from 'ah-common-lib/src/toast';
import { useTheme } from 'ah-theme';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyClientInformationSettingsView',
  setup(__props) {

const theme = useTheme();

const toast = useToast();

const files = ref<UploadedFile[]>([]);

const individualSettingsStore = useIndividualSettingsStore();

const supportEmail = computed(() => theme.val.helpEmail || 'info@alt21.com');

const client = computed(() => individualSettingsStore.client);

const companyFileCategories = [
  ClientFileCategories.SAMPLE_INVOICE,
  ClientFileCategories.INCORPORATED_DOCUMENT,
  ClientFileCategories.FINANCIAL_STATEMENT,
];

const numberOfFiles = computed(() =>
  files.value!.filter((file) => companyFileCategories.includes(file.category as ClientFileCategories))
);

function onClientSaved(client: Client) {
  individualSettingsStore.setClient(client);
  toast.success('Client updated successfully');
}

individualSettingsStore.loadClient(true);

return { __sfc: true,theme, toast, files, individualSettingsStore, supportEmail, client, companyFileCategories, numberOfFiles, onClientSaved, ClientCompanyDetailsEditor, FileUploadCounter, DocumentsUploader }
}

})